module.exports = __webpack_public_path__ + "img/done.cac69d66.svg";